<template>
  <v-card>
    <v-card-title class="font-weight-bold primary--text justify-space-between mb-4">
      Adicionar/Associar Credor
    </v-card-title>

    <v-card-text v-if="dataset.showForm">
      Preencha os campos abaixo com os dados do credor.
      <br>
      <br>
      <v-form ref="form" v-model="validForm">
        <v-row>
          <v-col>
            <v-text-field dense id="name" label="Nome completo" v-model="dataset.data.name" required
              :rules="[$rules.required]" outlined hide-details="auto" />
          </v-col>
        </v-row>

        <v-row>

          <v-col cols="12" sm="6">
            <v-text-field dense id="registration" :label="'CPF/CNPJ'"
              v-model="dataset.data.registration" required outlined hide-details="auto" v-mask="maskRegistration"
              :rules="rulesRegistration" />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field dense label="Telefone" v-model="dataset.data.phone_number" required outlined
              :rules="[$rules.required]" hide-details="auto">
            </v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isCNPJ">
          <v-col>
            <strong>Representante(s)</strong>
          </v-col>
        </v-row>

        <template v-if="isCNPJ">
          <v-card v-for="(rep, index) in dataset.data.representatives" :key="index" outlined class="mb-2">
            <v-card-title class="py-2 d-flex justify-space-between align-center">
              <span class="subtitle-2">Representante - {{ index + 1 }}</span>

              <v-btn icon color="red" v-if="dataset.data.representatives.length > 1"
                @click="removeRepresentative(index)" title="Remover representante">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider />

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field dense label="Nome do representante" v-model="rep.name" :rules="[$rules.required]"
                    outlined hide-details="auto" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field dense label="CPF do representante" v-model="rep.registration"
                    :rules="[$rules.required, $rules.cpf]" outlined hide-details="auto" v-mask="['###.###.###-##']" />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-file-input dense accept="image/png, image/jpeg, application/pdf" outlined prepend-icon=""
                    :rules="[$rules.required, $rules.fileSize(4)]" truncate-length="70" show-size counter required
                    hint="O arquivo não pode ser superior a 4MB" label="Documento de identificação" hide-details="auto"
                    @change="onRepresentativeFileSelected($event, index)" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>

        <v-row v-if="isCNPJ">
          <v-col>
            <v-btn small outlined color="primary" @click="addRepresentative">
              <v-icon left>mdi-plus</v-icon>
              Adicionar representante
            </v-btn>
          </v-col>
        </v-row>

        <v-row v-if="isCNPJ || (lawyerUserData && Number(lawyerUserData.is_executor) === 1)">
          <v-col>
            <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined counter
              :rules="[fileSize]" show-size multiple hint="Cada arquivo não pode ser superior a 4MB" hide-details="auto"
              :label="otherDocumentsLabel" v-model="dataset.data.company_other_files"
              :clearable="true" @change="onCompanyOtherFiles($event)" ref="other_files">
              <template v-slot:selection="{ text, index }">
                <v-chip small label color="primary" class="ma-1">
                  {{ dataset.data.company_other_files[index].name }}
                </v-chip>
              </template>

            </v-file-input>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field dense id="address_postal_code" label="CEP" v-model="dataset.data.address_postal_code" required
              :rules="[$rules.required, $rules.cep]" outlined hide-details="auto" v-mask="'##.###-###'"
              @blur="searchCep"></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-text-field dense id="address_street" label="Rua/Avenida" v-model="dataset.data.address_street" required
              :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-text-field dense id="address_number" label="Número" v-model="dataset.data.address_number" required
              :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="8">
            <v-text-field dense id="address_complement" label="Complemento" v-model="dataset.data.address_complement"
              outlined hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field dense id="address_neighborhood" label="Bairro" v-model="dataset.data.address_neighborhood"
              required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field dense id="address_city" label="Cidade" v-model="dataset.data.address_city" required
              :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4">
            <v-autocomplete dense id="address_state" label="Estado" :items="dataset.statesList" item-text="name"
              item-value="sigla" v-model="dataset.data.address_state" required :rules="[$rules.required]" outlined
              hide-details="auto"></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="8">
            <v-text-field dense class="mb-2" id="email" label="E-mail" v-model="dataset.data.email" required
              :rules="[$rules.required, $rules.email]" outlined hide-details="auto" />
          </v-col>

        </v-row>
        <v-row>
          <v-col>
            <v-file-input dense accept="image/png, image/jpeg, application/pdf" prepend-icon="" outlined counter
              required :rules="[$rules.required, $rules.fileSize(4)]" show-size
              hint="O arquivo não pode ser superior a 4MB" hide-details="auto"
              label="Documento de identificação (CPF, RG ou CNH)" :clearable="true" @change="onFileSelected($event)"
              ref="logoFile" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-text v-if="dataset.showForm">
      <!-- Se for inventariante (is_executor == 1) mostra botão específico e esconde o de gerar procuração -->
      <v-btn
        color="primary"
        v-if="lawyerUserData && Number(lawyerUserData.is_executor) === 1"
        @click="generateExecutorDocs"
        :loading="loading"
      >
        Associar
      </v-btn>

      <!-- Botão padrão para gerar procuração, visível quando NÃO for inventariante -->
      <v-btn
        color="primary"
        v-else
        @click="create"
        :loading="loading"
      >
        Gerar procuração
      </v-btn>

      <v-btn text class="grey--text" @click="$emit('fechar')">Cancelar</v-btn>
    </v-card-text>

    <v-divider class="my-3" v-if="procuracaoHtml"></v-divider>

    <v-card-text v-if="procuracaoHtml">
      <p class="subtitle-1 font-weight-bold mb-2">Pré-visualização da Procuração</p>

      <div class="scroll-box" v-html="procuracaoHtml"></div>

      <v-btn color="success" class="mt-4" @click="gerarPdf" :loading="loadingPdf">
        Gerar PDF Procuração
      </v-btn>
      <v-btn color="primary" class="mt-4 ml-5" @click="editProcuration" :loading="loading">
        Editar Procuração
      </v-btn>

      <input type="file" ref="fileInput" accept="application/pdf" style="display: none"
        @change="onProcurationSelected" />

      <v-btn class="grey--text mt-4 ml-5" @click="$emit('fechar')">
        Cancelar
      </v-btn>
    </v-card-text>
  </v-card>
</template>


<script>
import axios from "axios";
import string from "@/common/util/string";
import { eventHub } from "@/main";
import statesList from "@/common/data/states-list.data";

export default {
  data: () => ({
    validForm: false,
    loading: false,
    loadingPdf: false,
    lawyerUserData: null,
    user: null,
    dataset: {
      data: {
        name: '',
        registration: '',
        phone_number: '',
        email: '',
        address_street: '',
        address_number: '',
        address_complement: '',
        address_neighborhood: '',
        address_city: '',
        address_postal_code: '',
        address_state: null,
        representatives: [],
      },
      statesList: statesList,
      showForm: true, 
    },
    procuracaoHtml: '',
   
  }),

  computed: {
    isCNPJ() {
      const valor = this.dataset.data.registration;
      const resultado = valor && valor.length >= 18;

      return resultado;
    },

    cleanRegistration() {
      return (this.dataset.data.registration || '').replace(/\D/g, '')
    },

    maskRegistration() {
      if (this.dataset.data.is_foreign) return ''
      return this.cleanRegistration.length <= 11
        ? this.$masks.cpf
        : this.$masks.cnpj
    },

    otherDocumentsLabel () {
      if (this.lawyerUserData && Number(this.lawyerUserData.is_executor) === 1) {
        return 'Documentos do inventário (nomeação, termo, partilha, etc.)'
      }

      return 'Outros (contrato social, estatuto, ata, etc.)'
    },

    rulesRegistration() {
      if (this.dataset.data.is_foreign) {
        return [this.$rules.required]
      }

      return [
        this.$rules.required,
        v => {
          const digits = (v || '').replace(/\D/g, '')
          if (digits.length === 11) return this.$rules.cpf(digits)
          if (digits.length === 14) return this.$rules.cnpj(digits)
          return 'CPF ou CNPJ inválido'
        }
      ]
    },

  },

  watch: {
    isCNPJ(newValue) {
      if (!Array.isArray(this.dataset.data.representatives)) {
        this.$set(this.dataset.data, 'representatives', []);
      }

      if (newValue && this.dataset.data.representatives.length === 0) {
        this.addRepresentative();
      }

      if (!newValue) {
        this.dataset.data.representatives = [];
      }
    }
  },

  created() {
   this.user = this.$root.user || null

    if (this.user) {
      this.loadLawyerData()
    }
  },

  methods: {
    onFileSelected(file) {
      this.dataset.data.file = file;
    },

    openFilePicker() {
      // Abre a janela de seleção de arquivo
      this.$refs.fileInput.click();
    },

    async onProcurationSelected(event) {
     const file = event.target.files[0];

      if (!file) return;

      if (file.type !== "application/pdf") {
        this.$dialog.notify.error("O arquivo precisa ser um PDF válido.");
        return;
      }

      this.dataset.data.procuration_file = file;

      //await this.uploadProcuration();
    },

    // onRepresentativeFileSelected(representative_file) {
    //   this.dataset.data.representative_file = representative_file;
    // },

    onCompanyOtherFiles(files) {
      this.dataset.data.company_other_files = files.filter(file => file.size <= 4 * 1024 * 1024);
    },
            
    fileSize(value) {
        if (!value || value.length === 0) return true;
            const invalid = value.find(file => file.size > 4 * 1024 * 1024);
        return !invalid || 'Cada arquivo deve ter no máximo 4MB';
    },

    editProcuration(){
      this.procuracaoHtml = null;
      this.dataset.showForm = true;

    },

    onRepresentativeFileSelected (file, index) {
      this.dataset.data.representatives[index].file = file
    },

    async loadLawyerData() {

      try {

      const result = await axios.get('/api/lawyers/my-account')
      
      this.lawyerUserData = result.data.content.data
   
      } catch (error) {
        console.error('Erro ao carregar informações do procurador:', error)
      }

    },

    async create() {

      if (!this.$refs.form.validate()) return;

      const payload = this.buildPayload();

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja gerar o texto da procuração?',
        title: 'Gerar Procuração',
        actions: {
          false: 'Cancelar',
          true: 'Gerar'
        }
      });

      if (!proceedAction) return;

      this.procuracaoHtml = null;

      this.loading = true

      try {
        const response = await axios.post('/api/lawyers/create-template', payload)
        
        console.log("Resposta API: ", response)

        this.procuracaoHtml = response.data.content.content.template

        if(this.procuracaoHtml){
          this.dataset.showForm = false;
        }
        
      } catch (error) {
      
        console.error("Erro ao gerar texto da procuração:", error);

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          this.$dialog.notify.error(error.response.data.content.error.message, { position: 'top-right', timeout: 5000 });
        } else if (error && error.message) {
          this.$dialog.notify.error(error.message, { position: 'top-right', timeout: 5000 });
        } else {
          this.$dialog.notify.error("Erro ao gerar texto da procuração!", { position: 'top-right', timeout: 5000 });
        }
        
      } finally {
        this.loading = false
      }
    },

    async gerarPdf() {

      const registration = this.dataset.data.registration.replace(/[.-]/g, '')
      const now = new Date()
      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const footerDate = `${day}${month}${year}`
      const fileName = `procuracao_${registration}_${footerDate}.pdf`
      
      const payload = this.buildPayload();

      this.loadingPdf = true
      
      try {
        
        const response = await axios.post('/api/lawyers/create-template-pdf', payload, {
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$dialog.notify.success('PDF gerado com sucesso!')

        await this.$dialog.confirm({
          html: true,
          text: `
            Um novo credor foi adicionado à sua lista de Credores.<br><br>
            O arquivo PDF da procuração foi gerado e salvo na pasta configurada pelo sistema (geralmente a pasta <strong>Downloads</strong>, salvo se houver outra configuração).<br><br>
            Envie este arquivo ao credor para que ele realize a assinatura digital através da plataforma <strong>gov.br</strong>.
          `,
          title: 'Sucesso',
          actions: {
            true: 'OK'
          }
        });

        this.$emit('new-creditor');

        this.goBack();

      } catch (error) {

        let apiMessage = "Erro ao gerar PDF da procuração!";

        if (
          error &&
          error.response &&
          error.response.data instanceof Blob
        ) {
          try {
            const text = await error.response.data.text(); 
            const json = JSON.parse(text); 

            if (json.message) {
              apiMessage = json.message;
            }
          } catch (parseError) {
            console.error("Erro ao interpretar resposta da API:", parseError);
          }
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          apiMessage = error.response.data.message;
        } else if (error && error.message) {
          apiMessage = error.message;
        }

        this.$dialog.notify.error(apiMessage, {
          position: 'top-right',
          timeout: 5000
        });

      } finally {
        this.loadingPdf = false
      }
    },

    buildPayload() {
      const formData = new FormData();

      formData.append('name', this.dataset.data.name);
      formData.append('registration', string.sanitizeCpfCnpj(this.dataset.data.registration).replaceAll(' ', ''));
      formData.append('phone_number', string.sanitizePhone(this.dataset.data.phone_number));
      formData.append('email', this.dataset.data.email);
      formData.append('file', this.dataset.data.file);
      formData.append('address_postal_code', (this.dataset.data.address_postal_code || '').replace(/\D/g, ''));
      //formData.append('address_postal_code', this.dataset.data.address_postal_code);
      formData.append('address_street', this.dataset.data.address_street);
      formData.append('address_number', this.dataset.data.address_number);
      formData.append('address_complement', this.dataset.data.address_complement || '');
      formData.append('address_neighborhood', this.dataset.data.address_neighborhood);
      formData.append('address_city', this.dataset.data.address_city);
      formData.append('address_state', this.dataset.data.address_state);
      formData.append('is_executor', this.dataset.data.is_executor ? '1' : '0');

      if(this.isCNPJ){

        if (Array.isArray(this.dataset.data.representatives)) {
          this.dataset.data.representatives.forEach((rep, index) => {

            if (rep.name) {
              formData.append(
                `representatives[${index}][name]`,
                rep.name
              );
            }

            if (rep.registration) {
              const sanitized = string.sanitizeCpfCnpj(rep.registration) || '';
              formData.append(
                `representatives[${index}][registration]`,
                sanitized.replace(/ /g, '')
              );
            }

            if (rep.file instanceof File) {
              formData.append('representatives_files[]', rep.file);
              formData.append('representatives_order[]', index);
            }

          });
        }
      }

      if (Array.isArray(this.dataset.data.company_other_files)) {
        this.dataset.data.company_other_files.forEach(item => {
          if (item instanceof File) {
            formData.append("other_files", item);
          }
        });
      }

      return formData;
    },

    async generateExecutorDocs() {

      if (!this.$refs.form.validate()) return;

      const payload = this.buildPayload();

      const proceedAction = await this.$dialog.confirm({
        text: 'Deseja proceder com a associação?',
        title: 'Associar Credor',
        actions: {
          false: 'Cancelar',
          true: 'Associar'
        }
      });

      if (!proceedAction) return;

      this.procuracaoHtml = null;

      this.loading = true

      try {
        const response = await axios.post('/api/lawyers/create-executor-association', payload)
        
       
        await this.$dialog.confirm({
          html: true,
          text: `
            Um novo credor foi adicionado à sua lista de Credores.<br><br>
            Proceda com o envio do arquivo de procuração e aguarde a análise pelos administradores judiciais.<br><br>`,
          title: 'Sucesso',
          actions: {
            true: 'OK'
          }
        });

        this.$emit('new-creditor');

        this.goBack();
        
      } catch (error) {

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          this.$dialog.notify.error(error.response.data.content.error.message, { position: 'top-right', timeout: 5000 });
        } else if (error && error.message) {
          this.$dialog.notify.error(error.message, { position: 'top-right', timeout: 5000 });
        } else {
          this.$dialog.notify.error("Erro ao efetuar a associação com o credor!", { position: 'top-right', timeout: 5000 });
        }
        
      } finally {
        this.loading = false
       
      }
    },

    async searchCep() {
      const cep = this.dataset.data.address_postal_code.replace(/\D/g, '')
      if (cep.length !== 8) {
        return
      }

      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
        const data = response.data

        if (!data.erro) { 
          this.dataset.data.address_street = data.logradouro
          this.dataset.data.address_neighborhood = data.bairro
          this.dataset.data.address_city = data.localidade
          this.dataset.data.address_state = data.uf 
        } else {
          this.dataset.data.address_street = ''
          this.dataset.data.address_neighborhood = ''
          this.dataset.data.address_city = ''
          this.dataset.data.address_state = null
         
        }
      } catch (error) {
        this.dataset.data.address_street = ''
        this.dataset.data.address_neighborhood = ''
        this.dataset.data.address_city = ''
        this.dataset.data.address_state = null
      }
    },

    goBack() {
      this.dataset.data.file = null;
      this.dataset.data.procuration_file = null;
      this.dataset.data = {};
      this.$emit('fechar');
    },

    addRepresentative() {
      const data = this.dataset && this.dataset.data
        ? this.dataset.data
        : (this.dataset.data = {})

      if (!Array.isArray(data.representatives)) {
        this.$set(data, 'representatives', [])
      }

      if (data.representatives.length >= 2) {
        this.$dialog.notify.warning(
          'É permitido adicionar no máximo 2 representantes.'
        )
        return
      }

      data.representatives.push({
        name: '',
        registration: '',
        file: null
      })
    },

    removeRepresentative(index) {
      this.dataset.data.representatives.splice(index, 1)
    },

  }
};
</script>

<style lang="scss">
.title-page {
  color: var(--v-primary-base);
  font-family: Montserrat;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

p {
  text-align: justify;
}

.scroll-box {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  background-color: #fafafa;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  line-height: 1.6;
}
</style>
